import { useDispatch, useSelector } from "react-redux";

import type { BaseActivatedPanelProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { selectActiveLeadsType, selectActiveSearchResultsDto } from "app/pages/sales-intelligence/modules/leads-search";
import { useListParams } from "app/pages/sales-intelligence/modules/lists/context/ListParamsContext";
import { exportTopNLeadsToSfThunk } from "app/pages/sales-intelligence/pages/opportunity-list/store/effects";
import { exportDomainsToSFThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/salesforce/export";
import { selectExportingToSF } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforce/exportSelectors";

import CrmExportPanelContainer from "./CrmExportPanelContainer";

const SalesforceExportPanelContainer = (props: BaseActivatedPanelProps) => {
    const dispatch = useDispatch();

    const exportIsInProgress = useSelector(selectExportingToSF);
    const activeLeadsType = useSelector(selectActiveLeadsType);
    const searchResultsDto = useSelector(selectActiveSearchResultsDto);

    const listParams = useListParams();

    const handleExportNDomains = (domainsCount: number, countries: readonly number[]): void => {
        void dispatch(
            exportTopNLeadsToSfThunk({
                domainsCount,
                countries,
                leadsType: activeLeadsType,
                dto: searchResultsDto,
                listParams,
            }),
        );
    };

    const handleExportDomains = (domains: readonly string[], countries: readonly number[]): void => {
        void dispatch(exportDomainsToSFThunk(domains, countries, activeLeadsType, listParams.id));
    };

    return (
        <CrmExportPanelContainer
            integration="salesforce"
            isExportInProgress={exportIsInProgress}
            label={{ key: "si.multi_selector.salesforce.title" }}
            onDeactivate={props.onDeactivate}
            onExportNDomains={handleExportNDomains}
            onExportDomains={handleExportDomains}
        />
    );
};

export default SalesforceExportPanelContainer;
